function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m14.907 26.6665c-4.4414 0-7.69143-3.7798-7.69143-8.2213 0-1.7418 2.77006-3.1463 3.96523-3.6713.3481-.1528.7358-.1747 1.1054-.0859.9562.2299 1.5826 1.1471 1.4489 2.1214l-.7777 5.6649c-.0592.4312.2759.8155.7111.8155.3984 0 .7206.3245.7178.7229l-.0023.3171c-.0041.5733.4595 1.0401 1.0327 1.0401h.524.6247c.5938 0 1.0751-.4814 1.0751-1.0751v-.2878c0-.4037.3128-.7383.7156-.7655.4437-.03.769-.4296.7085-.8701l-.7718-5.6177c-.1352-.9839.5227-1.9017 1.4979-2.0896.3353-.0646.6803-.0378.9937.0978 1.1611.5025 4.022 1.9202 4.022 3.6904 0 4.4411-3.2637 8.2142-7.7047 8.2142zm4.9653-16.2576c0 2.0668-1.684 3.7419-3.7616 3.7419-2.0791 0-3.7626-1.6756-3.7626-3.7419 0-2.06728 1.6835-3.7424 3.7626-3.7424 2.0776 0 3.7616 1.67512 3.7616 3.7424z",
  fill: "#303030",
  fillRule: "evenodd"
});

function SvgLawyer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32
  }, props), _ref);
}

export default "data:image/svg+xml;base64,";
export { SvgLawyer as ReactComponent };